/* eslint-disable arrow-body-style */
import { Box, Flex } from '@chakra-ui/react';
import { Icon } from '@mesh.ai/rabbit';

import { TextHeader4, TextLabel } from 'uiToolkitV1/Typography';

const StepCardBox = ({ children }) => {
  return (
    <Box p={2} display="flex" gap="8px" borderRadius="8px" bgColor="surface.F5F7F9">
      <Box px={4} py={3} bgColor="white" borderRadius="8px" flex={1}>
        {children}
      </Box>
    </Box>
  );
};

const StepCard = ({ title = 'Installation Steps', rightComp, headerRightComp, children }) => {
  return (
    <StepCardBox>
      <Box display="flex" flex={1} justifyContent="space-between" gap="24px">
        {/* left content */}
        <Box display="flex" flexDir="column" gap={!rightComp ? '12px' : '16px'} flexGrow={1}>
          <Flex
            justifyContent="space-between"
            borderBottom={!rightComp ? '1px solid' : 'none'}
            borderColor="border.EBEFF3"
            pb={!rightComp ? 2 : 0}
            alignItems="center"
          >
            <TextHeader4 bold>{title}</TextHeader4>
            {headerRightComp}
          </Flex>
          {children}
        </Box>

        {/* right content */}
        {rightComp}
      </Box>
    </StepCardBox>
  );
};

// **********************************************************
const NumberIconStep = ({ index, stepComp, withPaddingBottom = true }) => {
  return (
    <Box display="flex" gap="16px" pb={withPaddingBottom ? '24px' : '0'}>
      <Box
        bgColor="surface.EBEFF3"
        borderRadius="50%"
        w="20px"
        h="20px"
        display="flex"
        justifyContent="center"
        alignItems="center"
        zIndex={1}
        flexShrink={0}
      >
        <TextLabel color="text.g2" bold>
          {index + 1}
        </TextLabel>
      </Box>

      {stepComp}
    </Box>
  );
};

const NumberIconSteps = ({ stepsComps = [] }) => {
  if (!stepsComps || stepsComps.length === 0) return null;

  return (
    <>
      <Box display="flex" flexDir="column" position="relative">
        <Box w="1px" bgColor="surface.F5F7F9" position="absolute" height="100%" left="10px" top="0" zIndex="0" />
        {/* render n-1 steps, for the purpose of connector line height to be till n-1 step */}
        {stepsComps.slice(0, -1).map((stepComp, index) => (
          <NumberIconStep index={index} stepComp={stepComp} />
        ))}
      </Box>
      {/* render nth step with */}
      <NumberIconStep
        index={stepsComps.length - 1}
        stepComp={stepsComps[stepsComps.length - 1]}
        withPaddingBottom={false}
      />
    </>
  );
};

const IconSteps = ({ steps = [] }) => {
  if (!steps || steps.length === 0) return null;

  return (
    <>
      {steps.map((step, index) => {
        const { iconSvg, stepComp } = step;
        return (
          // eslint-disable-next-line react/no-array-index-key
          <Box display="flex" gap="8px" py={2} key={index} alignItems="center">
            {/* <Icon boxSize="24px" color="icon.g2" /> */}
            <Icon IconSVG={iconSvg} style={{ color: '#666' }} />
            {stepComp}
          </Box>
        );
      })}
    </>
  );
};
// **********************************************************

export { StepCard, StepCardBox, NumberIconSteps, IconSteps };
